import { useState, useEffect } from "react";
import { Nav, Aside } from "./Styled-Navbar";
import { listItems, data } from "./data";
import { allProducts } from "../../AllProducts";
import { useSelector } from "react-redux";
import { FaAlignJustify } from "react-icons/fa";
import "./navbar.css";
import { Link } from "react-router-dom";

export default function Navbar() {
  let count = useSelector((state) => state.count);
  let name = useSelector((state) => state.name);
  let [index, setIndex] = useState(8);
  let [result, setResult] = useState([]);
  const mouseOver = (e) => {
    e.currentTarget.classList.add("height");
  };
  // console.log(name);

  const mouseOut = (e) => {
    e.currentTarget.classList.remove("height");
  };

  document.body.addEventListener("click", function (e) {
    let article = document.querySelector("#search-results");
    if (e.target.parentElement.id === "search-results") {
      article.style.visibility = "visible";
    } else {
      article.style.visibility = "hidden";
    }
    // console.log(e.target.parentElement);
  });

  useEffect(() => {
    document.querySelectorAll("li")[index].classList.add("li");
    return () => {
      document.querySelectorAll("li")[index].classList.remove("li");
    };
  });

  const inpHandler = (e) => {
    let article = document.querySelector("#search-results");
    let newArr = [];
    for (let i = 0; i < allProducts.length; i++) {
      if (allProducts[i].name.toLowerCase().includes(e.target.value)) {
        newArr.push(allProducts[i]);
      }
    }
    if (newArr.length && e.target.value) {
      setResult(newArr);
      article.style.visibility = "visible";
    } else {
      article.style.visibility = "hidden";
    }
  };
  const modalClose = (e) => {
    e.target.parentElement.style.transform = "translateX(-100%)";
  };
  const modalOpen = () => {
    let ele = document.querySelector("#hidden-menu");
    ele.style.transform = "translateX(0)";
  };

  const submenuHandler = (e) => {
    if (e.target.classList.contains("main-para")) {
    }
    if (e.target.classList.contains("sub-para")) {
    }
  };
  return (
    <>
      <FaAlignJustify id="hidden-menu-open" onClick={modalOpen} />
      <Aside id="hidden-menu">
        <button onClick={modalClose}>X</button>
        <article>
          <Link to="/">
            <svg
              id="logo"
              viewBox="0 0 87 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              width="156"
              height="36"
              iconsize="20"
              className="Icon-sc-1iwi4w1-0 KPTtb"
            >
              <path
                d="M12.844 6.814c1.453.011 2.677.516 3.685 1.507 1.02.998 1.523 2.188 1.512 3.593L18 18.522c-.006.788-.668 1.423-1.488 1.423-.815-.006-1.471-.646-1.465-1.434l.04-6.608a2.048 2.048 0 00-.661-1.57c-.428-.43-.967-.646-1.6-.646a2.227 2.227 0 00-1.664.686c-.416.42-.621.997-.627 1.581l-.035 6.511c-.006.8-.68 1.446-1.506 1.44-.826-.006-1.494-.657-1.488-1.457l.04-6.55a2.21 2.21 0 00-.603-1.56c-.45-.464-1.002-.69-1.658-.696a2.236 2.236 0 00-1.611.629c-.434.425-.668.946-.668 1.558l-.041 6.602c-.006.794-.674 1.434-1.494 1.429-.82-.006-1.477-.652-1.471-1.445l.041-6.58a4.928 4.928 0 011.29-3.32c1.083-1.168 2.419-1.752 3.972-1.74 1.482.01 2.748.526 3.761 1.575 1.043-1.043 2.297-1.542 3.78-1.536zm18.682 7.316l-8.479-.052c.07 1.02.41 1.83 1.008 2.436.603.596 1.377.902 2.32.907.738.006 1.348-.159 1.834-.499.287-.204.598-.504.932-.918a1.434 1.434 0 011.787-.362l.088.045a1.32 1.32 0 01.369 2.034 7.51 7.51 0 01-.287.318 6.416 6.416 0 01-1.389 1.11 5.61 5.61 0 01-1.594.63c-.574.13-1.19.198-1.857.192-1.91-.011-3.445-.617-4.594-1.813-1.148-1.202-1.717-2.794-1.705-4.772.012-1.96.586-3.542 1.717-4.743 1.143-1.19 2.643-1.78 4.512-1.763 1.886.012 3.375.601 4.459 1.774 1.078 1.162 1.61 2.76 1.6 4.806a.703.703 0 01-.721.67zm-2.32-2.359c-.405-1.53-1.395-2.3-2.972-2.306a2.985 2.985 0 00-1.013.153 2.928 2.928 0 00-.867.453c-.258.198-.48.436-.668.714a3.24 3.24 0 00-.428.952l5.947.034zM45.64 14.13l-8.478-.052c.07 1.02.41 1.83 1.007 2.436.604.596 1.377.902 2.32.907.739.006 1.348-.159 1.835-.499.287-.204.597-.504.931-.918a1.434 1.434 0 011.787-.362l.088.045a1.32 1.32 0 01.37 2.034 7.442 7.442 0 01-.288.318 6.416 6.416 0 01-1.388 1.11 5.61 5.61 0 01-1.594.63c-.574.13-1.19.198-1.857.192-1.91-.011-3.446-.617-4.594-1.813-1.149-1.202-1.717-2.794-1.705-4.772.012-1.96.586-3.542 1.717-4.743 1.142-1.19 2.642-1.78 4.511-1.763 1.887.012 3.375.601 4.46 1.774 1.077 1.162 1.61 2.76 1.599 4.806a.703.703 0 01-.72.67zm-2.32-2.359c-.405-1.53-1.395-2.3-2.971-2.306a2.985 2.985 0 00-1.014.153 2.928 2.928 0 00-1.535 1.167 3.24 3.24 0 00-.427.952l5.947.034zM61.976 0c.838.006 1.506.663 1.5 1.474l-.062 6.478c1.084-.93 2.277-1.14 3.578-1.134 1.3.006 2.66.566 3.539 1.501.75.81 1.113 2.103 1.101 3.871l-.047 6.302c-.005.81-.685 1.456-1.523 1.45-.838-.005-1.506-.663-1.5-1.473l.041-6.024c.006-1.014-.176-1.751-.54-2.204-.368-.46-.966-.692-1.792-.692-1.055-.006-1.805.306-2.238.935-.428.64-.645 1.74-.657 3.298l-.035 4.664c-.005.81-.685 1.457-1.523 1.451-.838-.005-1.506-.663-1.5-1.473l.129-16.962c.012-.822.691-1.468 1.53-1.462zM73.44 13.46c.012-1.751.668-3.236 1.975-4.454 1.3-1.219 2.888-1.825 4.746-1.808 1.869.011 3.451.64 4.746 1.887 1.277 1.241 1.91 2.766 1.898 4.562-.012 1.82-.668 3.332-1.974 4.556-1.313 1.213-2.918 1.808-4.81 1.797-1.882-.012-3.446-.646-4.712-1.899-1.254-1.235-1.88-2.782-1.869-4.641zm2.96.068c-.007 1.213.316 2.17.984 2.879.68.72 1.582 1.082 2.707 1.088 1.13.006 2.039-.34 2.718-1.043.68-.703 1.026-1.638 1.037-2.816.006-1.18-.322-2.12-.996-2.828-.68-.714-1.582-1.083-2.707-1.088-1.107-.006-2.004.345-2.695 1.054-.691.708-1.037 1.626-1.049 2.754zm-19.405-.257c.907.664 1.363 1.53 1.38 2.582v.044c0 1.286-.507 2.348-1.453 3.067-.868.66-2.073 1.008-3.476 1.008-1.492 0-3.064-.42-4.427-1.177a1.362 1.362 0 01-.485-1.967 1.443 1.443 0 011.2-.626c.248 0 .49.06.704.18 1.042.577 2.107.882 3.076.882 1.532 0 1.695-.74 1.695-1.062v-.044c0-.648-.884-.953-2.332-1.378-.101-.033-.197-.06-.293-.087-.963-.267-1.965-.589-2.743-1.144-.924-.665-1.374-1.537-1.374-2.67v-.044c0-2.326 1.949-3.955 4.737-3.955 1.172 0 2.45.283 3.617.806.36.164.642.463.766.834a1.36 1.36 0 01-.113 1.106l-.006.005a1.449 1.449 0 01-1.256.714c-.214 0-.417-.043-.608-.13-.907-.41-1.763-.627-2.479-.627-.912 0-1.504.37-1.504.948v.043c0 .67 1.172 1.03 2.411 1.417l.242.076c.952.284 1.938.632 2.721 1.199z"
                fill="#F43397"
              ></path>
            </svg>
          </Link>
          <Link to="/profile">
            <p id="profile-pic-modal">
              <img
                src="https://www.svgrepo.com/show/284856/profile-user.svg"
                alt=""
              />
              <h2>Hello {name}!</h2>
            </p>
          </Link>
          <h3>Categories</h3>
          {listItems.map((i, index) => (
            <p className="main-para" onClick={submenuHandler} key={index}>
              {i}
              <img
                src="https://www.svgrepo.com/show/60060/down-arrow.svg"
                alt=""
              />
              {data[index].map((items, inde) => (
                <p className="sub-para" onClick={submenuHandler} key={inde}>
                  {items[0]}
                  <img
                    src="https://www.svgrepo.com/show/60060/down-arrow.svg"
                    alt=""
                  />
                  {items.map((item, ind) => (
                    <Link to={`/products/${i}/${item}`}>
                      <p className="sub-sub-para" key={ind}>
                        {ind !== 0 && item}
                      </p>
                    </Link>
                  ))}
                </p>
              ))}
            </p>
          ))}
        </article>
      </Aside>
      <Nav>
        <section id="top">
          <Link to="/">
            <svg
              id="logo"
              viewBox="0 0 87 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              width="156"
              height="36"
              iconsize="20"
              className="Icon-sc-1iwi4w1-0 KPTtb"
            >
              <path
                d="M12.844 6.814c1.453.011 2.677.516 3.685 1.507 1.02.998 1.523 2.188 1.512 3.593L18 18.522c-.006.788-.668 1.423-1.488 1.423-.815-.006-1.471-.646-1.465-1.434l.04-6.608a2.048 2.048 0 00-.661-1.57c-.428-.43-.967-.646-1.6-.646a2.227 2.227 0 00-1.664.686c-.416.42-.621.997-.627 1.581l-.035 6.511c-.006.8-.68 1.446-1.506 1.44-.826-.006-1.494-.657-1.488-1.457l.04-6.55a2.21 2.21 0 00-.603-1.56c-.45-.464-1.002-.69-1.658-.696a2.236 2.236 0 00-1.611.629c-.434.425-.668.946-.668 1.558l-.041 6.602c-.006.794-.674 1.434-1.494 1.429-.82-.006-1.477-.652-1.471-1.445l.041-6.58a4.928 4.928 0 011.29-3.32c1.083-1.168 2.419-1.752 3.972-1.74 1.482.01 2.748.526 3.761 1.575 1.043-1.043 2.297-1.542 3.78-1.536zm18.682 7.316l-8.479-.052c.07 1.02.41 1.83 1.008 2.436.603.596 1.377.902 2.32.907.738.006 1.348-.159 1.834-.499.287-.204.598-.504.932-.918a1.434 1.434 0 011.787-.362l.088.045a1.32 1.32 0 01.369 2.034 7.51 7.51 0 01-.287.318 6.416 6.416 0 01-1.389 1.11 5.61 5.61 0 01-1.594.63c-.574.13-1.19.198-1.857.192-1.91-.011-3.445-.617-4.594-1.813-1.148-1.202-1.717-2.794-1.705-4.772.012-1.96.586-3.542 1.717-4.743 1.143-1.19 2.643-1.78 4.512-1.763 1.886.012 3.375.601 4.459 1.774 1.078 1.162 1.61 2.76 1.6 4.806a.703.703 0 01-.721.67zm-2.32-2.359c-.405-1.53-1.395-2.3-2.972-2.306a2.985 2.985 0 00-1.013.153 2.928 2.928 0 00-.867.453c-.258.198-.48.436-.668.714a3.24 3.24 0 00-.428.952l5.947.034zM45.64 14.13l-8.478-.052c.07 1.02.41 1.83 1.007 2.436.604.596 1.377.902 2.32.907.739.006 1.348-.159 1.835-.499.287-.204.597-.504.931-.918a1.434 1.434 0 011.787-.362l.088.045a1.32 1.32 0 01.37 2.034 7.442 7.442 0 01-.288.318 6.416 6.416 0 01-1.388 1.11 5.61 5.61 0 01-1.594.63c-.574.13-1.19.198-1.857.192-1.91-.011-3.446-.617-4.594-1.813-1.149-1.202-1.717-2.794-1.705-4.772.012-1.96.586-3.542 1.717-4.743 1.142-1.19 2.642-1.78 4.511-1.763 1.887.012 3.375.601 4.46 1.774 1.077 1.162 1.61 2.76 1.599 4.806a.703.703 0 01-.72.67zm-2.32-2.359c-.405-1.53-1.395-2.3-2.971-2.306a2.985 2.985 0 00-1.014.153 2.928 2.928 0 00-1.535 1.167 3.24 3.24 0 00-.427.952l5.947.034zM61.976 0c.838.006 1.506.663 1.5 1.474l-.062 6.478c1.084-.93 2.277-1.14 3.578-1.134 1.3.006 2.66.566 3.539 1.501.75.81 1.113 2.103 1.101 3.871l-.047 6.302c-.005.81-.685 1.456-1.523 1.45-.838-.005-1.506-.663-1.5-1.473l.041-6.024c.006-1.014-.176-1.751-.54-2.204-.368-.46-.966-.692-1.792-.692-1.055-.006-1.805.306-2.238.935-.428.64-.645 1.74-.657 3.298l-.035 4.664c-.005.81-.685 1.457-1.523 1.451-.838-.005-1.506-.663-1.5-1.473l.129-16.962c.012-.822.691-1.468 1.53-1.462zM73.44 13.46c.012-1.751.668-3.236 1.975-4.454 1.3-1.219 2.888-1.825 4.746-1.808 1.869.011 3.451.64 4.746 1.887 1.277 1.241 1.91 2.766 1.898 4.562-.012 1.82-.668 3.332-1.974 4.556-1.313 1.213-2.918 1.808-4.81 1.797-1.882-.012-3.446-.646-4.712-1.899-1.254-1.235-1.88-2.782-1.869-4.641zm2.96.068c-.007 1.213.316 2.17.984 2.879.68.72 1.582 1.082 2.707 1.088 1.13.006 2.039-.34 2.718-1.043.68-.703 1.026-1.638 1.037-2.816.006-1.18-.322-2.12-.996-2.828-.68-.714-1.582-1.083-2.707-1.088-1.107-.006-2.004.345-2.695 1.054-.691.708-1.037 1.626-1.049 2.754zm-19.405-.257c.907.664 1.363 1.53 1.38 2.582v.044c0 1.286-.507 2.348-1.453 3.067-.868.66-2.073 1.008-3.476 1.008-1.492 0-3.064-.42-4.427-1.177a1.362 1.362 0 01-.485-1.967 1.443 1.443 0 011.2-.626c.248 0 .49.06.704.18 1.042.577 2.107.882 3.076.882 1.532 0 1.695-.74 1.695-1.062v-.044c0-.648-.884-.953-2.332-1.378-.101-.033-.197-.06-.293-.087-.963-.267-1.965-.589-2.743-1.144-.924-.665-1.374-1.537-1.374-2.67v-.044c0-2.326 1.949-3.955 4.737-3.955 1.172 0 2.45.283 3.617.806.36.164.642.463.766.834a1.36 1.36 0 01-.113 1.106l-.006.005a1.449 1.449 0 01-1.256.714c-.214 0-.417-.043-.608-.13-.907-.41-1.763-.627-2.479-.627-.912 0-1.504.37-1.504.948v.043c0 .67 1.172 1.03 2.411 1.417l.242.076c.952.284 1.938.632 2.721 1.199z"
                fill="#F43397"
              ></path>
            </svg>
          </Link>
          <div>
            <svg
              width="20"
              height="20"
              className="DFW_E nT46U VETef"
              viewBox="0 0 32 32"
              version="1.1"
              aria-hidden="false"
            >
              <path d="M22 20c1.2-1.6 2-3.7 2-6 0-5.5-4.5-10-10-10S4 8.5 4 14s4.5 10 10 10c2.3 0 4.3-.7 6-2l6.1 6 1.9-2-6-6zm-8 1.3c-4 0-7.3-3.3-7.3-7.3S10 6.7 14 6.7s7.3 3.3 7.3 7.3-3.3 7.3-7.3 7.3z"></path>
            </svg>
            <form action="">
              <input
                type="text"
                onChange={inpHandler}
                placeholder="Try Saree, Kurti or Search by Product Code"
              />
            </form>
            <svg
              width="20"
              height="20"
              className="VdNCI nT46U VETef"
              viewBox="0 0 32 32"
              version="1.1"
              aria-hidden="false"
            >
              <path d="M6.7 25.3H12V28H6.7C5.2 28 4 26.8 4 25.3V20h2.7v5.3zm0-18.6H12V4H6.7C5.2 4 4 5.2 4 6.7V12h2.7V6.7zM25.3 4H20v2.7h5.3V12H28V6.7C28 5.2 26.8 4 25.3 4zm0 21.3H20V28h5.3c1.5 0 2.7-1.2 2.7-2.7V20h-2.7v5.3zm-4-9.3c0 2.9-2.4 5.3-5.3 5.3s-5.3-2.4-5.3-5.3 2.4-5.3 5.3-5.3 5.3 2.4 5.3 5.3zm-2.6 0c0-1.5-1.2-2.7-2.7-2.7s-2.7 1.2-2.7 2.7 1.2 2.7 2.7 2.7 2.7-1.2 2.7-2.7z"></path>
            </svg>
            <article id="search-results">
              {result.map((i, index) => (
                <Link to={`/product/${i.id}`}>
                  <p id={index} key={index}>
                    <svg
                      width="18"
                      height="18"
                      className="DFW_E nT46U VETef"
                      viewBox="0 0 32 32"
                      version="1.1"
                      aria-hidden="false"
                    >
                      <path d="M22 20c1.2-1.6 2-3.7 2-6 0-5.5-4.5-10-10-10S4 8.5 4 14s4.5 10 10 10c2.3 0 4.3-.7 6-2l6.1 6 1.9-2-6-6zm-8 1.3c-4 0-7.3-3.3-7.3-7.3S10 6.7 14 6.7s7.3 3.3 7.3 7.3-3.3 7.3-7.3 7.3z"></path>
                    </svg>
                    <span>{i.name}</span>
                  </p>
                </Link>
              ))}
            </article>
          </div>
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.meesho.supply&pid=pow_website&c=pow"
            rel="noreferrer"
          >
            <p id="mobile">
              <img
                src="https://www.svgrepo.com/show/371405/mobile.svg"
                alt=""
              />
              Download App
              <div>
                <p>Download From</p>
                <img
                  src="https://images.meesho.com/images/pow/homepage/google-play-button.jpg"
                  alt=""
                />
                <img
                  src="https://images.meesho.com/images/pow/homepage/appstore-button.jpg"
                  alt=""
                />
              </div>
            </p>
          </a>
          <p className="line">|</p>
          <a
            href="https://meesho-supplier-harsh.netlify.app"
            target="_blank"
            rel="noreferrer"
          >
            <p>Become a Supplier</p>
          </a>
          <p className="line">|</p>
          <Link to="/profile">
            <p id="profile">
              <img
                src="https://www.svgrepo.com/show/284856/profile-user.svg"
                alt=""
              />
              Profile
              <div>
                <h2>Hello {name}!</h2>
                <p>to access your meesho account</p>
                <button>SIGN UP</button>
                <p>Go to Your Orders</p>
              </div>
            </p>
          </Link>
          <Link to={name === "User" ? "/profile" : "/checkout/cart"}>
            <p id="cart">
              <span>{count}</span>
              <svg
                id="cart"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                className="bi bi-cart-check"
                viewBox="0 0 16 16"
              >
                <path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z" />{" "}
                <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />{" "}
              </svg>
              Cart
            </p>
          </Link>
        </section>
        <section id="bottom" onMouseOver={mouseOver} onMouseOut={mouseOut}>
          <ul>
            {listItems.map((i, index) => (
              <Link to={`/products/${i}`} key={index}>
                <li key={index} id={index} onMouseOver={() => setIndex(index)}>
                  {i}
                </li>
              </Link>
            ))}
          </ul>
          <article onMouseOut={mouseOut}>
            {data[index].map((items, i) => (
              <div key={i}>
                {items.map((item, ind) => (
                  <Link to={`/products/${listItems[index]}`}>
                    <p key={ind} className={ind === 0 ? "pink-para" : ""}>
                      <Link to={`products/${listItems[index]}/${items[ind]}`}>
                        {item}
                      </Link>
                    </p>
                  </Link>
                ))}
              </div>
            ))}
          </article>
        </section>
      </Nav>
    </>
  );
}
